/**
 * Where an `EXPORT_FINISHED` notification leads (docs/plans/PLAN_channel-and-account-export.md §5.2).
 *
 * The server puts the destination in `metadata.link`: the Exportações page of the
 * export's account, or the contact drawer for a contact export. A superadmin may
 * have asked for the export while switched into another account (D5), so the
 * session has to move to `metadata.accountId` before the page opens.
 */
export const EXPORT_FINISHED = "EXPORT_FINISHED";

// Only same-app paths may be navigated to from a notification payload.
const isInternalPath = (value) =>
  typeof value === "string" && value.startsWith("/") && !value.startsWith("//");

/**
 * @returns {{ path: string, switchToAccountId: string|null } | null}
 *   null when the notification is not an export one or carries no usable link.
 */
export function resolveExportNotificationTarget(notification, { currentAccountId, isSuperAdmin }) {
  if (notification?.type !== EXPORT_FINISHED) return null;
  const metadata = notification.metadata || {};
  if (!isInternalPath(metadata.link)) return null;

  const targetAccountId = metadata.accountId || null;
  const needsSwitch =
    isSuperAdmin === true && !!targetAccountId && targetAccountId !== currentAccountId;

  return { path: metadata.link, switchToAccountId: needsSwitch ? targetAccountId : null };
}
